import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '~/src/layouts/component-layout';
import { Link, Text } from '@primer/react';
import { Link as GatsbyLink } from 'gatsby';
import { AccessibilityLink } from '~/src/components/accessibility-link';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Box = makeShortcode("Box");
const CustomVideoPlayer = makeShortcode("CustomVideoPlayer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h2>{`Usage`}</h2>
    <Box display="flex" flexDirection={['column', 'column', 'column', 'column', 'row']} sx={{
      alignItems: 'flex-start',
      gap: 3
    }} mdxType="Box">
      <div>
        <p>{`A spinner is an indeterminate loading indicator, meaning it's best for cases where the progress or duration of a process is variable or unknown.`}</p>
        <p>{`A spinner may be shown on it's own or paired with a loading message. Spinners may be used as a placeholder for loading content, or just as an indicator that some action is being processed.`}</p>
        <p>{`More detailed guidance about designing for loading states can be found in our `}<a parentName="p" {...{
            "href": "/ui-patterns/loading"
          }}>{`loading guidelines`}</a>{`.`}</p>
      </div>
      <CustomVideoPlayer src="https://github.com/primer/design/assets/2313998/50234598-852a-46fc-be07-72bb6f35691b" width="456" autoPlay loop mdxType="CustomVideoPlayer" />
    </Box>
    <h2>{`Options`}</h2>
    <Box display="flex" flexDirection={['column', 'column', 'column', 'column', 'row']} sx={{
      alignItems: 'flex-start',
      gap: 3
    }} mdxType="Box">
      <div>
        <h3>{`Size`}</h3>
        <p>{`The size of the spinner can be adjusted. The `}<strong parentName="p">{`medium`}</strong>{` (default) variant works best for most cases. The `}<strong parentName="p">{`small`}</strong>{` variant is optimized for being displayed inline with loading text. The `}<strong parentName="p">{`large`}</strong>{` variant works well for replacing entire regions or pages that are still loading.`}</p>
      </div>
      <img src="https://github.com/primer/design/assets/2313998/b31c4058-929f-471c-860e-6a8c2c6af21e" width="960" role="presentation" />
    </Box>
    <h2>{`Accessibility`}</h2>
    <p>{`By default, our spinner component provides a generic loading status announcement for assistive technologies. We recommend that you specify a custom announcement specific to your use-case. For example: "Loading changed files".`}</p>
    <p>{`To avoid duplicate announcements when a loading message is already being displayed in context, the component allows engineers to suppress the spinner's default loading announcement.`}</p>
    <h3>{`Known accessibility issues (GitHub staff only)`}</h3>
    <AccessibilityLink label="Spinner" mdxType="AccessibilityLink" />
    <h2>{`Related links`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/ui-patterns/loading"
        }}>{`Loading guidelines`}</a></li>
    </ul>
    {/* TODO: link to Skeleton loaders once they're merged */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      